import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getDummyText } from "../../utils";

const getTokenMockUrl = (type) =>
    `./mock-data/gated-content/token-${type}.json`;
const getFormMockUrl = (type) => `./mock-data/gated-content/form-${type}.json`;

export default {
    title: "Components/Gated Content",
    component: "ux-iws-gated-content",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        buttonText: "Kostenlos registrieren",
        verifyTokenUrl: getTokenMockUrl("valid"),
        formAction: getFormMockUrl("valid"),
    },
    argTypes: {
        buttonText: {
            control: "text",
        },
        verifyTokenUrl: {
            control: "select",
            options: [
                getTokenMockUrl("valid"),
                getTokenMockUrl("invalid"),
                getTokenMockUrl("blocked"),
                getTokenMockUrl("error"),
            ],
        },
        formAction: {
            control: "select",
            options: [
                getFormMockUrl("valid"),
                getFormMockUrl("validation"),
                getFormMockUrl("existing"),
                getFormMockUrl("blocked"),
                getFormMockUrl("error"),
            ],
        },
    },
};

const Template = (args) => html`
    <ux-iws-gated-content
        verify-token-url="${args.verifyTokenUrl}"
        button-text="${args.buttonText}"
    >
        <div slot="overlay-content">Overlay Content</div>
        <div slot="form">
            <ux-form>
                <form action="${args.formAction}">
                    <ux-input-field
                        type="email"
                        label="email"
                        name="email"
                        required
                    ></ux-input-field>
                    <br />
                    <ux-button type="submit">Absenden</ux-button>
                </form>
            </ux-form>
        </div>
        <div slot="loading">Willkommen zurück!</div>
        <div slot="submitting">Wir prüfen Ihre Daten...</div>
        <div slot="thanks">Noch ein Schritt...</div>
        <div slot="blocked">Zugriff nicht möglich!</div>
        <div slot="error">Es ist leider ein Fehler aufgetreten.</div>
        <div slot="content">${getDummyText(200)}</div>
    </ux-iws-gated-content>
`;

export const Default = Template.bind({});
